{
  "AUTOMATION": {
    "HEADER": "Automatização",
    "DESCRIPTION": "A automação pode substituir e racionalizar os processos existentes que requerem esforço manual, como a adição de etiquetas e a atribuição de conversas ao agente mais adequado. Isto permite que a equipa se foque em tarefas maiores, reduzindo o tempo gasto em tarefas rotineiras.",
    "LEARN_MORE": "Saber mais sobre automação",
    "HEADER_BTN_TXT": "Adicionar regra de automação",
    "LOADING": "A procurar regras de automação",
    "ADD": {
      "TITLE": "Adicionar regra de automação",
      "SUBMIT": "Criar",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "FORM": {
        "NAME": {
          "LABEL": "Nome da regra",
          "PLACEHOLDER": "Insira o nome da regra",
          "ERROR": "Nome é obrigatório"
        },
        "DESC": {
          "LABEL": "Descrição",
          "PLACEHOLDER": "Insira descrição da regra",
          "ERROR": "Descrição é obrigatória"
        },
        "EVENT": {
          "LABEL": "Evento",
          "PLACEHOLDER": "Por favor, selecione um",
          "ERROR": "Evento é necessário"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Ordem",
          "ERROR": "A ordem é obrigatória"
        },
        "CONDITIONS": {
          "LABEL": "Condições"
        },
        "ACTIONS": {
          "LABEL": "Ações"
        }
      },
      "CONDITION_BUTTON_LABEL": "Adicionar condição",
      "ACTION_BUTTON_LABEL": "Adicionar ação",
      "API": {
        "SUCCESS_MESSAGE": "Regra de automação adicionada com sucesso",
        "ERROR_MESSAGE": "Não foi possível criar uma regra de automação, por favor, tente novamente mais tarde"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fase",
        "ORDER": "Ordem",
        "NAME": "Nome:",
        "DESCRIPTION": "Descrição",
        "ACTIVE": "Ativa",
        "CREATED_ON": "Criado em",
        "WAIT": "Espera"
      },
      "404": "Nenhuma regra de automação encontrada",
      "TABS": {
        "ALL": "Todas",
        "INSTANT": "No evento",
        "DELAYED": "Com atraso"
      },
      "WAITS": "Aguarda {duration}"
    },
    "DELETE": {
      "TITLE": "Apagar regra de automação",
      "SUBMIT": "Excluir",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem a certeza que pretende excluir a automação ",
        "YES": "Sim, excluir ",
        "NO": "Não, manter "
      },
      "API": {
        "SUCCESS_MESSAGE": "Regra de automação excluída com sucesso",
        "ERROR_MESSAGE": "Não foi possível excluir a regra de automação, por favor, tente novamente mais tarde"
      }
    },
    "EDIT": {
      "TITLE": "Editar regra de automação",
      "SUBMIT": "Atualização",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Regra de automação atualizada com sucesso",
        "ERROR_MESSAGE": "Não foi possível atualizar a regra de automação, por favor, tente novamente mais tarde"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automação clonada com sucesso",
        "ERROR_MESSAGE": "Não foi possível clonar a regra de automação, por favor, tente novamente mais tarde"
      }
    },
    "FORM": {
      "EDIT": "Editar",
      "CREATE": "Criar",
      "DELETE": "Excluir",
      "CANCEL": "Cancelar",
      "RESET_MESSAGE": "Alterar o tipo de evento irá redefinir as condições e eventos adicionados abaixo"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "É necessário ter, pelo menos, uma condição para guardar",
      "CONTACT_CUSTOM_ATTR_LABEL": "Atributos personalizados do contacto",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Atributos personalizados da conversa"
    },
    "ACTION": {
      "DELETE_MESSAGE": "É necessário ter, pelo menos, uma ação para guardar",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Introduza aqui a sua mensagem",
      "TEAM_DROPDOWN_PLACEHOLDER": "Selecionar equipas",
      "EMAIL_INPUT_PLACEHOLDER": "Inserir e-mail",
      "URL_INPUT_PLACEHOLDER": "Inserir URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Selecione a caixa de entrada de e-mail e o endereço de envio",
      "SUBJECT_INPUT_PLACEHOLDER": "Assunto do e-mail",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Selecione a caixa de entrada SMS a partir da qual enviar",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Introduza o texto do SMS",
      "SMS_COUNTER": "{length}/{limit} carateres, {segments} SMS (antes de as variáveis serem preenchidas)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Ativar regra de automação",
      "DEACTIVATION_TITLE": "Desativar regra de automação",
      "ACTIVATION_DESCRIPTION": "Esta ação irá ativar a regra de automação '{automationName}'. Tem a certeza que pretende continuar?",
      "DEACTIVATION_DESCRIPTION": "Esta ação irá desativar a regra de automação '{automationName}'. Tem a certeza que pretende continuar?",
      "ACTIVATION_SUCCESFUL": "Regra de automação ativada com sucesso",
      "DEACTIVATION_SUCCESFUL": "Regra de automação desativada com sucesso",
      "ACTIVATION_ERROR": "Não foi possível ativar a automação. Por favor, tente novamente mais tarde",
      "DEACTIVATION_ERROR": "Não foi possível desativar a automação. Por favor, tente novamente mais tarde",
      "CONFIRMATION_LABEL": "Sim",
      "CANCEL_LABEL": "Não"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Não foi possível carregar anexo, por favor, tente novamente",
      "LABEL_IDLE": "Carregar anexo",
      "LABEL_UPLOADING": "A carregar...",
      "LABEL_UPLOADED": "Anexo carregado com sucesso",
      "LABEL_UPLOAD_FAILED": "Falha ao carregar anexo"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "A chave do atributo é necessária",
      "FILTER_OPERATOR_REQUIRED": "Operador do filtro é necessário",
      "VALUE_REQUIRED": "Valor obrigatório",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "O valor deve ser entre 1 e 998",
      "ACTION_PARAMETERS_REQUIRED": "Os parâmetros de ação são obrigatórios",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Pelo menos uma condição é obrigatória",
      "ATLEAST_ONE_ACTION_REQUIRED": "Pelo menos uma ação é obrigatória"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Esta ação só funciona quando a fase da regra está definida como \"Antes da etiquetagem\".",
      "SKIP_AUTO_LABELING": "Esta ação só funciona quando a fase da regra está definida como \"Antes da etiquetagem\".",
      "MOVE_CONVERSATION_TO_INBOX": "Apenas as conversas de e-mail e de chat web podem ser movidas para uma caixa de entrada de e-mail, e um chat web apenas se o contacto tiver endereço de e-mail. Caso contrário, a conversa permanece onde está e, em vez disso, é adicionada uma nota privada.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Inicia uma nova conversa com o contacto na caixa de entrada de e-mail selecionada, envia-lhe a mensagem por e-mail e resolve a conversa. Isto acontece sempre que a regra é executada. Se o contacto não tiver endereço de e-mail, nada é enviado e é adicionada uma nota privada.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Inicia uma nova conversa com o contacto na caixa de entrada SMS selecionada, envia-lhe a mensagem por SMS e resolve a conversa. Isto acontece sempre que a regra é executada. A mensagem é texto simples, sem anexos. Se o contacto não tiver número de telefone, nada é enviado e é adicionada uma nota privada."
    },
    "NOTICES": {
      "AI_PROMPT": "Cada avaliação individual é cobrada.",
      "INCOMING_MESSAGES_COUNT": "Refere-se ao número de mensagens recebidas na conversa.",
      "OUTGOING_MESSAGES_COUNT": "Refere-se ao número de mensagens enviadas na conversa."
    },
    "PHASE": {
      "BEFORE_LABELING": "Antes da etiquetagem",
      "AFTER_LABELING": "Depois da etiquetagem"
    },
    "NONE_OPTION": "Nenhuma",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Mensagem recebida",
      "OUTGOING": "Mensagem enviada",
      "PRIVATE": "Nota privada",
      "AI_SUMMARY": "Resumo da IA"
    },
    "YES_NO_VALUES": {
      "YES": "Sim",
      "NO": "Não"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Mensagem direta do Instagram",
      "FACEBOOK_COMMENT": "Comentário do Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversa criada",
      "CONVERSATION_UPDATED": "Conversa atualizada",
      "MESSAGE_CREATED": "Mensagem criada",
      "CONVERSATION_OPENED": "Conversa aberta",
      "CONVERSATION_RESOLVED": "Conversa resolvida",
      "PHONE_CALL_FINISHED": "Chamada finalizada"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Atribuir a um agente",
      "ASSIGN_TEAM": "Atribuir uma equipa",
      "ADD_LABEL": "Adicionar uma etiqueta",
      "REMOVE_LABEL": "Remover uma etiqueta",
      "SEND_EMAIL_TO_TEAM": "Enviar um e-mail para a equipa",
      "SEND_EMAIL_TRANSCRIPT": "Enviar uma transcrição por e-mail",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Enviar uma transcrição detalhada por e-mail",
      "MUTE_CONVERSATION": "Silenciar conversa",
      "SNOOZE_CONVERSATION": "Adiar conversa",
      "RESOLVE_CONVERSATION": "Resolver conversa",
      "OPEN_CONVERSATION": "Abrir conversa",
      "SEND_WEBHOOK_EVENT": "Enviar evento de webhook",
      "SEND_ATTACHMENT": "Enviar anexo",
      "SEND_MESSAGE": "Enviar uma mensagem",
      "ADD_NOTE": "Adicionar uma nota",
      "CHANGE_PRIORITY": "Alterar prioridade",
      "ADD_SLA": "Adicionar SLA",
      "SKIP_AUTO_PRIORITY": "Ignorar prioridade automática",
      "SKIP_AUTO_LABELING": "Ignorar etiquetagem automática",
      "AUTO_TRANSLATE": "Traduzir mensagem",
      "AUTO_TRANSLATE_CONVERSATION": "Traduzir conversa",
      "MOVE_CONVERSATION_TO_INBOX": "Mover conversa para caixa de entrada",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Enviar uma mensagem numa nova conversa",
      "SEND_SMS_IN_NEW_CONVERSATION": "Enviar SMS numa nova conversa",
      "STOP_PROCESSING_RULES": "Parar de processar regras"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Filtro de IA",
      "MESSAGE_TYPE": "Tipo de mensagem",
      "MESSAGE_CONTAINS": "Conteúdo da mensagem",
      "EMAIL": "E-mail",
      "INBOX": "Caixa de entrada",
      "CHANNEL_TYPE": "Tipo de caixa de entrada",
      "CONVERSATION_LANGUAGE": "Idioma da conversa",
      "PHONE_NUMBER": "Número de telefone",
      "STATUS": "Estado",
      "BROWSER_LANGUAGE": "Idioma do navegador",
      "MAIL_SUBJECT": "Assunto do e-mail",
      "COUNTRY_NAME": "País",
      "MARKETPLACE_COUNTRY": "País do marketplace",
      "REFERER_LINK": "Link de referência",
      "ASSIGNEE_NAME": "Agente atribuído",
      "TEAM_NAME": "Equipa",
      "PRIORITY": "Prioridade",
      "CALL_DIRECTION": "Direção da chamada",
      "MISSED_CALL": "Chamada perdida",
      "MISSED_CALL_COUNT": "Número de chamadas perdidas",
      "MESSAGE_SOURCE_TYPE": "Tipo de origem da mensagem",
      "INCOMING_MESSAGE_COUNT": "Número de mensagens recebidas",
      "OUTGOING_MESSAGE_COUNT": "Número de mensagens enviadas",
      "LABEL": "Etiqueta",
      "EMAIL_RECIPIENTS": "Destinatário do e-mail",
      "EMAIL_AUTO_REPLY": "O e-mail é uma resposta automática",
      "ATTACHMENT_EXTENSION": "Extensão do anexo",
      "EXTENSION": "Extensão chamada",
      "WORKING_HOURS": "Dentro do horário de trabalho",
      "AGENT_REPLIED": "Um agente respondeu desde a mudança de estado"
    },
    "WAIT": {
      "RUN_LABEL": "Executar as ações",
      "INSTANT": "No evento",
      "DELAYED": "Com atraso",
      "TRIGGER_LABEL": "Aguardar até que",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Uma conversa permanece num estado",
        "CUSTOMER_UNRESPONSIVE": "O cliente não responde a um agente",
        "AGENT_UNRESPONSIVE": "O cliente não recebe resposta de um agente"
      },
      "STATUS_LABEL": "Estado",
      "STATUSES": {
        "OPEN": "Aberta",
        "PENDING": "Pendente",
        "SNOOZED": "Adiada",
        "RESOLVED": "Resolvida"
      },
      "DELAY_LABEL": "Tempo de espera",
      "DELAY_ERROR": "Introduza um tempo de espera entre 1 minuto e 30 dias",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "As ações são executadas quando uma conversa está no estado {status} há {duration}. Uma mudança de estado antes cancela-as. As etiquetas, o horário de trabalho e as respostas dos agentes são verificados quando a espera termina.",
        "CUSTOMER_UNRESPONSIVE": "As ações são executadas quando o cliente não responde há {duration} à mensagem de um agente. Uma resposta do cliente cancela-as; uma nova mensagem do agente reinicia a espera.",
        "AGENT_UNRESPONSIVE": "As ações são executadas quando o cliente espera há {duration} sem resposta de um agente. Uma resposta do agente cancela-as."
      }
    }
  }
}
